<template>
  <intro-container>
    <div class="d-flex justify-center align-center fill-height">
      <div class="landing__container">
        <h1>{{ $t("landing.title") }}</h1>
        <niko-button
          :text="$t('landing.button.login')"
          width="100%"
          class="mt-12"
          primary
          @onClick="startAuthentication(true)"
        />
        <niko-button
          :text="$t('landing.button.signup')"
          width="100%"
          class="mt-8"
          @onClick="startAuthentication(false)"
        />
      </div>
    </div>
  </intro-container>
</template>

<script>
import NikoButton from "@/components/UI/NikoButton";
import IntroContainer from "@/components/IntroContainer";
import {
  AUTH_ATTEMPTED_KEY,
  REDIRECT_TO_AFTER_AUTH_KEY,
} from "@/utils/constants";

export default {
  name: "landing",
  components: {
    NikoButton,
    IntroContainer,
  },
  methods: {
    startAuthentication(isLogin) {
      localStorage.setItem(AUTH_ATTEMPTED_KEY, true);

      const redirectUrl = this.$router.currentRoute.query.redirect;
      if (redirectUrl) {
        localStorage.setItem(REDIRECT_TO_AFTER_AUTH_KEY, redirectUrl);
      } else {
        localStorage.setItem(REDIRECT_TO_AFTER_AUTH_KEY, "/");
      }

      if (isLogin) {
        window.location.href = `${process.env.VUE_APP_NIKO_ID_URL}/login?redirect_uri=${process.env.VUE_APP_API_URL}/tokens`;
      } else {
        window.location.href = `${process.env.VUE_APP_NIKO_ID_URL}/signUp?redirect_uri=${process.env.VUE_APP_API_URL}/tokens`;
      }
    },
  },
};
</script>

<style lang="scss">
.landing {
  &__container {
    flex-basis: 356px;
  }
}
</style>
